import c from "lodash";
import w from "@patsnap-biz/icon";
import "@patsnap-ui/icon/assets/solid/SpaceShared.svg";
import "@patsnap-ui/icon/assets/solid/company.svg";
import "@patsnap-ui/icon/assets/solid/3d.svg";
import "@patsnap-ui/icon/assets/solid/edit.svg";
import "@patsnap-ui/icon/assets/solid/FolderAdd.svg";
import { resolveComponent as y, openBlock as n, createElementBlock as p, normalizeClass as _, createElementVNode as d, createVNode as S, withModifiers as T, withDirectives as I, withKeys as R, vModelText as A, Fragment as v, toDisplayString as h, createBlock as g, createCommentVNode as m, withCtx as L, normalizeStyle as z, renderList as E, createTextVNode as P, mergeProps as x, renderSlot as K, defineComponent as q, provide as V, unref as W } from "vue";
import "@patsnap-ui/icon/assets/solid/FolderClosed2.svg";
import "@patsnap-ui/icon/assets/solid/autoFolder.svg";
import "@patsnap-ui/icon/assets/solid/DropdownOpen.svg";
import "@patsnap-ui/icon/assets/solid/DropdownRight.svg";
import { ElTooltip as j } from "element-plus";
import "@patsnap-ui/icon/assets/solid/NoDataTip.svg";
import "@patsnap-ui/icon/assets/solid/LoadingBars.svg";
import "@patsnap-ui/icon/assets/solid/CloseMedium.svg";
import "@patsnap-ui/icon/assets/solid/AddMedium.svg";
import "@patsnap-ui/icon/assets/solid/SearchLeft.svg";
import D from "@patsnap-biz/dialog";
import "@patsnap-ui/icon/assets/solid/info.svg";
import "@patsnap-ui/icon/assets/solid/DropdownClose.svg";
import { useI18n as H } from "vue-i18n";
function Q(o, e, t, s, a = "children") {
  const r = c.cloneDeep(o);
  return c.filter(r, (l) => {
    const f = r.filter((u) => l[t] === u[s]);
    return f.length > 0 && (l[a] = f), l[s] === e;
  });
}
function N(o = [], e = "children", t = "id", s = "parent", a = "-root") {
  const r = [];
  function i(l, f) {
    return c.forEach(l, (u) => {
      r.push(u), u[s] = f, u[e] && u[e].length && i(u[e], u[t]);
    }), r;
  }
  return i(o, a);
}
function B(o) {
  return o ? o.scrollIntoViewIfNeeded ? (o.scrollIntoViewIfNeeded(), !0) : (o.scrollIntoView(), !0) : !1;
}
const M = /^([a-zA-Z0-9_\[\]\{\}'"\-\.\,\?\&\/\(\)\s]|[^\u0000-\u007F])*$/;
class G {
  constructor() {
    this.isSubmitting = !1, this.type = "PAPER", this.baseUrl = "", this.axiosInstance = null, this.successSaveTipClassName = "save-to-workspace-success-toast", this.errorCodeI18nPrefix = "commonStatusCode", this.workspaceProductDomain = "", this.t = "", this.searchGroupMode = {
      searchMode: "",
      // 同族库(family)  公开库(publication)
      groupMode: "",
      // 分组类型 默认为 ALL
      selectedGroupCounts: 0
      // 选中同族背后实际专利数量
    }, this.enableRange = !1, this.folderSelector = {
      enableFoldersSearch: !0,
      maxFolderLevel: 10,
      folderLoopProtectionFlag: 10,
      folderNameHighlightClassName: "folder-name-heighlight-key",
      promiseUID: c.uniqueId(),
      loading: !1,
      selectedWorkspace: null,
      selectedFolder: null,
      latestType: "ADD",
      // 标识是最新保存/复制/移动   ADD,COPY,MOVE
      latestWorkspaceId: null,
      latestFolderId: null,
      folderSearchKeywords: "",
      lastFolderSearchKeywords: "",
      response: null,
      workspaceGroupList: [],
      get selfWorkspaceList() {
        return c.get(this.workspaceGroupList, "[0].workspaces", []);
      },
      get workspaceList() {
        const e = [];
        return c.forEach(this.workspaceGroupList, ({ workspaces: t }) => {
          e.push(...t);
        }), e;
      },
      initWorkspaceScroll: !1,
      // 是否进行过初始滚动;
      initFolderScroll: !1
    }, this.rangeSelector = {
      disabledTypes: ["ALL", "RANGE"],
      selectedType: "ALL",
      error: void 0,
      warning: "",
      from: 1,
      to: 1,
      min: 1,
      // 输入最小值
      max: -1,
      // 可预期的最大输入值
      maxInputLimit: 1e4,
      // 开始值最大值不能超过这个数
      allCounts: 0,
      // 用于范围选择验证中，如果普通就是allCounts, 如果是同族分组下,则就是groupCounts
      addLimit: 0,
      // 最大选择范围
      countMax: 0
    };
  }
  tErrorCode(e, t) {
    const s = `${this.errorCodeI18nPrefix}.${e}`, a = `${this.errorCodeI18nPrefix}.400`;
    return this.te(s) ? this.t(s, t) : this.t(a);
  }
  http(e) {
    const t = {
      ...e
    };
    return t.headers = {
      "X-API-Version": "2.0",
      ...t.headers || {}
    }, this.axiosInstance(t).then((s) => {
      if (c.get(s, "data.status"))
        return s.data.data;
      const a = c.get(s, "data.error_code", 400), r = c.get(s, "data.error_params") || {};
      return Promise.reject({
        _error_code: a,
        _error_msg: this.tErrorCode(a, r)
      });
    }).catch((s) => {
      if (s && s._error_code)
        return Promise.reject(s);
      let a = 400;
      try {
        const { code: r, message: i } = s.toJSON();
        a = r || {
          "Network Error": 440
        }[i] || 400;
      } catch {
        a = 400;
      }
      return Promise.reject({
        _error_code: a,
        _error_msg: this.tErrorCode(a)
      });
    });
  }
  isSubmitButtonDisabled() {
    return !!(!this.verifyRange() || this.isSubmitting || this.folderSelector.loading || !this.folderSelector.selectedFolder || c.get(this.folderSelector.selectedWorkspace, "isLoading"));
  }
  formatNumber(e) {
    return parseInt(`0${e}`, 10) <= 0 ? 0 : `${new Intl.NumberFormat("en-US", { style: "decimal" }).format(e)}`;
  }
  init() {
    this.initFolderSelector();
  }
  onToastError({ message: e }) {
    return e;
  }
  onError(e, { module: t }) {
    return t !== "FolderSelector" || !e || !e._error_msg ? console.log("[SaveToWorkspace Error]: ", e) : this.onToastError({ message: e._error_msg });
  }
  handleJumpToWorkspaceLink({
    folder_id: e,
    // folder_name,
    space_id: t,
    source_type: s,
    data_type: a
  }) {
    const r = this.type_alias || a || this.type || "PATENT", i = `?spaceId=${t}&folderId=${e}&page=1&from=${s || ""}`;
    return `${this.workspaceProductDomain}/detail/${c.toLower(r)}/folders` + i;
  }
  generateToWorkspaceLink({
    folder_id: e,
    folder_name: t,
    space_id: s,
    source_type: a,
    data_type: r
  }) {
    const i = this.handleJumpToWorkspaceLink({
      folder_id: e,
      folder_name: t,
      space_id: s,
      source_type: a,
      data_type: r
    }), l = `<a href="${i}" class="${this.successSaveTipClassName}__link" target="_blank">${t}</a>`;
    return {
      link: i,
      linkTpl: l,
      template: `
                <div class="${this.successSaveTipClassName}">
                    <p>${this.t("BaseSaveToWorkspace.Main.saveToWorkspaceLink", { link: l })}</p>
                </div>
            `
    };
  }
  getCurrentParams() {
    const {
      enableRange: e,
      folderSelector: t,
      rangeSelector: s
    } = this, { from: a, to: r, allCounts: i } = s, l = {
      folderId: void 0,
      workspaceId: void 0,
      counts: 0,
      isRange: !1,
      isAll: !1,
      from: a,
      to: r
    };
    e && s.selectedType === "RANGE" ? (l.isRange = !0, l.counts = r - a + 1) : (l.isAll = !0, l.counts = i, l.from = 1, l.to = i);
    const { folder_id: f } = t.selectedFolder || {}, { space_id: u } = t.selectedWorkspace || {};
    return f && (l.folderId = f), u && (l.workspaceId = u), l;
  }
  getSubmitApiConfig() {
    throw new Error({
      _error_msg: "Please implementation method <getSubmitApiConfig>"
    });
  }
  async onSubmit() {
    this.isSubmitting = !0;
    const { folder_name: e, folder_id: t } = this.folderSelector.selectedFolder, { space_name: s, space_id: a } = this.folderSelector.selectedWorkspace;
    let r = {};
    try {
      r = await this.generateSubmitSaveToWorkspaceParams(this.getCurrentParams());
    } catch (l) {
      this.onError(l, { module: "Submit" });
      return;
    }
    const i = {
      ...r,
      folder_name: e,
      space_name: s,
      folder_id: t,
      space_id: a
    };
    this.http({
      ...this.getSubmitApiConfig(),
      data: r
    }).then(() => {
      this.isSubmitting = !1, this.onClose(
        this.generateToWorkspaceLink(i)
      );
    }).catch((l) => {
      this.isSubmitting = !1, l && l._error_msg ? this.rangeSelector.warning = l._error_msg : this.onError(l, { module: "Submit" });
    });
  }
  // folder-selector
  generateSubmitSaveToWorkspaceParams() {
    return Promise.reject(new Error({
      _error_msg: "Please implementation method <generateSubmitSaveToWorkspaceParams>"
    }));
  }
  initFolderSelector() {
    this.fetchWorkspaces().then(() => {
      if (!this.folderSelector.response)
        return;
      const e = c.get(this.folderSelector, "response.addLimit");
      this.rangeSelector.addLimit = e, this.rangeSelector.disabledTypes = [];
      const { maxInputLimit: t, allCounts: s } = this.rangeSelector;
      this.rangeSelector.max = Math.min(s, t, e), this.rangeSelector.to = this.rangeSelector.max, this.rangeSelector.countMax = s, s > this.rangeSelector.max && (this.rangeSelector.selectedType = "RANGE", this.rangeSelector.disabledTypes = ["ALL"]), this.verifyRange();
    });
  }
  getWorkspaceGroupType({ is_public_space: e, is_shared_space: t }) {
    return e ? "public" : t ? "shared" : "self";
  }
  getSearchParams() {
    const { folderSearchKeywords: e, latestType: t } = this.folderSelector;
    return {
      need_share_space: !0,
      need_public_space: !0,
      folder_search_name: e,
      data_type: this.type,
      operate_type: t
    };
  }
  fetchWorkspaces() {
    const { folderSearchKeywords: e } = this.folderSelector, t = this.getSearchParams();
    this.folderSelector.loading = !0, this.folderSelector.workspaceGroupList = [], this.folderSelector.latestWorkspaceId = null, this.folderSelector.latestFolderId = null, this.folderSelector.initWorkspaceScroll = !1, this.folderSelector.initFolderScroll = !1, this.selectWorkspace(null).then(() => {
      this.selectFolder(null);
    }).catch(() => {
    }), this.folderSelector.promiseUID = c.uniqueId();
    const { promiseUID: s } = this.folderSelector;
    return this.folderSelector.lastFolderSearchKeywords = e, this.http({
      url: `${this.baseUrl}/space/self-share-public`,
      method: "POST",
      data: t
    }).then((a) => {
      if (this.folderSelector.promiseUID !== s)
        return;
      this.folderSelector.response = c.cloneDeep(a);
      const r = c.map(
        [
          ...c.sortBy(c.get(this.folderSelector.response, "self") || [], ({ update_ts: u }) => -new Date(u)),
          ...c.sortBy(c.get(this.folderSelector.response, "shared") || [], ({ update_ts: u }) => -new Date(u)),
          ...c.sortBy(c.get(this.folderSelector.response, "public") || [], ({ update_ts: u }) => -new Date(u))
        ],
        (u) => u
      ), i = c.groupBy(r, (u) => this.getWorkspaceGroupType(u));
      if (this.folderSelector.workspaceGroupList = [
        { type: "self", expand: !1, workspaces: i.self || [] },
        { type: "shared", expand: !1, workspaces: i.shared || [] },
        { type: "public", expand: !1, workspaces: i.public || [] }
      ], !r || !r.length) {
        this.folderSelector.loading = !1;
        return;
      }
      let l = r[0];
      if (!e) {
        const {
          folder_id: u,
          space_id: k
        } = c.get(a, "goal_workspace_folder") || {};
        if (k && u) {
          this.folderSelector.latestWorkspaceId = k, this.folderSelector.latestFolderId = u;
          const C = c.find(r, { space_id: k });
          C && (l = C);
        }
      }
      this.selectWorkspace(l).then(() => {
        const { latestFolderId: u, selectedWorkspace: k } = this.folderSelector;
        let C = c.get(k, "folderTreeData[0]");
        e || (C = c.find(k.folderTreeList, { folder_id: u }) || C), this.selectFolder(C), k && !c.isEqual(C, k.folderTreeData[0]) && this.expandFolderParent({
          workspace: k,
          folder: C
        });
      }).catch(() => {
      });
      const f = this.getWorkspaceGroupType(l || {});
      c.forEach(this.folderSelector.workspaceGroupList, (u) => {
        e && (u.expand = !0), u.type === f && (u.expand = !0);
      }), this.folderSelector.loading = !1;
    }).catch((a) => {
      this.folderSelector.loading = !1, this.onError(a, { module: "FolderSelector" });
    });
  }
  fetchFolders({ workspace: e, folder_search_name: t }) {
    const { space_id: s } = e;
    return e.isLoading = !0, this.http({
      url: `${this.baseUrl}/space/search-folder`,
      method: "POST",
      data: { space_id: s, folder_search_name: t }
    }).then((a) => {
      const r = c.uniqBy(a, "folder_id");
      return r.length !== a.length && console.warn(
        "[Folder Selector] 存在相同key的folder",
        s,
        [r.length, a.length]
      ), t && c.forEach(r, (i) => {
        i.expand = !0;
      }), e.isLoading = !1, e.folder_info_simples = r, e.folderTreeData = Q(
        e.folder_info_simples,
        "-root",
        "folder_id",
        "parent_id"
      ), e.folderTreeList = N(e.folderTreeData), r;
    }).catch((a) => {
      e.isLoading = !1, e.folder_info_simples = [], e.folderTreeData = [], e.folderTreeList = [], this.onError(a, { module: "FolderSelector" });
    });
  }
  getWorkspaceIcon(e) {
    const { is_shared_space: t, is_public_space: s } = e || {};
    return t ? "SolidSpaceShared" : s ? "SolidCompany" : "Solid3D";
  }
  getFolderIcon() {
    return "SolidFolderClosed2";
  }
  getWorkspaceElementsCountString() {
  }
  getFolderElementsCountString() {
  }
  hasEditWorkspacePermission(e) {
    const { edit_definition: t = !1 } = e || {};
    return t;
  }
  hasAddWorkspaceFolderPermission(e) {
    const { permission_detail: t } = e || {};
    return t ? !!c.get(t, "folder_create", !1) : !0;
  }
  hasEditFolderPermission({ folder: e }) {
    return e.can_edit;
  }
  hasAddSubFolderPermission({ folder: e, level: t }) {
    return t + 1 >= this.folderSelector.maxFolderLevel ? !1 : e.can_add;
  }
  toggleFolderExpand({ folder: e }) {
    const t = !e.expand;
    e.expand = t;
  }
  expandFolderParent({ workspace: e, folder: t }) {
    const s = N(e.folderTreeData) || [];
    let a = t;
    for (; a; )
      a = c.find(s, { folder_id: a.parent_id }), a && (a.expand = !0);
  }
  finishEditWorkspace(e) {
    if (!this.isWorkspaceNameValid(e)) {
      c.assign(e, { space_name: e.originSpaceName }), e.isEditing = !1;
      return;
    }
    if (!e.isNew && e.space_name === e.originSpaceName) {
      e.isEditing = !1;
      return;
    }
    e.isUpdating = !1;
    const {
      space_id: t,
      space_name: s,
      space_desc: a,
      space_icon: r
    } = e;
    return this.http({
      url: `${this.baseUrl}/space/${t}`,
      method: "PUT",
      data: {
        space_name: s,
        space_desc: a,
        space_icon: r
      }
    }).then((i) => (c.assign(e, i), e.isUpdating = !1, e.isEditing = !1, e.isNew && e.folderTreeData && e.folderTreeData.length && (delete e.isNew, this.editFolder({
      workspace: e,
      folder: e.folderTreeData[0]
    })), i)).catch((i) => {
      e.isUpdating = !1, this.onError(i, { module: "FolderSelector" });
    });
  }
  editWorkspace(e) {
    return this.hasEditWorkspacePermission(e) ? (e.isEditing = !0, e.originSpaceName = e.space_name, !0) : !1;
  }
  isWorkspaceNameValid(e) {
    return e.space_name ? M.test(e.space_name) : !1;
  }
  finishEditFolder({ workspace: e, folder: t, parentFolder: s }) {
    if (!this.isFolderNameValid({ workspace: e, folder: t })) {
      if (t.isNew) {
        const i = s ? s.children : e.folderTreeData, l = c.findIndex(i, { folder_id: t.folder_id });
        l > -1 && i.splice(l, 1);
        return;
      }
      c.assign(t, { folder_name: t.originFolderName }), t.isEditing = !1;
      return;
    }
    if (!t.isNew && t.folder_name === t.originFolderName) {
      t.isEditing = !1;
      return;
    }
    t.isUpdating = !0;
    const a = {
      ...t,
      space_id: e.space_id
    };
    let r = null;
    return a.isNew ? (delete a.folder_id, a.parent_id = s ? s.folder_id : "-root", r = this.http({
      url: `${this.baseUrl}/space/${a.space_id}/folder`,
      method: "PUT",
      data: a
    })) : r = this.http({
      url: `${this.baseUrl}/${a.space_id}/folder/${a.folder_id}`,
      method: "POST",
      data: a
    }), r.then((i) => (c.assign(t, i), delete t.isNew, t.isUpdating = !1, t.isEditing = !1, this.isFolderDisabled({ workspace: e, folder: t }) || c.isEqual(e, this.folderSelector.selectedWorkspace) && this.selectFolder(t), i)).catch((i) => {
      t.isUpdating = !1, this.onError(i, { module: "FolderSelector" });
    });
  }
  editFolder({ workspace: e, folder: t }) {
    return this.hasEditFolderPermission({ workspace: e, folder: t }) ? (t.isEditing = !0, t.originFolderName = t.folder_name, !0) : !1;
  }
  isFolderNameValid({ folder: e }) {
    return e.folder_name ? M.test(e.folder_name) : !1;
  }
  isFolderDisabled() {
    return !1;
  }
  folderDisabledMsg() {
    return "";
  }
  renderFolderName({ folder: e }) {
    const t = e.folder_name, { lastFolderSearchKeywords: s, folderNameHighlightClassName: a } = this.folderSelector;
    if (!s || !t)
      return t;
    const r = s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    return t.replace(
      new RegExp(r, "ig"),
      (i) => `<span class="${a}">${i}</span>`
    );
  }
  addFolder({ workspace: e, parentFolder: t }) {
    let s = [];
    if (t ? (t.expand || (t.expand = !0), t.children || (t.children = []), s = t.children) : s = e.folderTreeData, !s)
      return;
    const a = this.t("BaseSaveToWorkspace.FolderSelector.newFolderName");
    let r = a;
    for (let l = 1; l < 2e3 && c.find(s, { folder_name: r }); l += 1)
      r = `${a} ${l}`;
    const i = {
      isNew: !0,
      // 接口创建完成后，会删除此字段;
      isNewCreate: !0,
      // 接口创建完成后前端将会保留此字段;
      folder_id: c.uniqueId(),
      folder_name: r,
      patent_count: 0,
      folder_auto_update: !1,
      can_edit: !0,
      folder_desc: "",
      parent_id: t ? t.folder_id : "-root"
    };
    s.push(i), this.editFolder({
      workspace: e,
      folder: i
    });
  }
  addWorkspace() {
    if (this.folderSelector.loading)
      return;
    const e = this.t("BaseSaveToWorkspace.FolderSelector.newWorkspaceName");
    let t = e;
    for (let s = 1; s < 2e3 && c.find(this.folderSelector.selfWorkspaceList, { space_name: t }); s += 1)
      t = `${e} ${s}`;
    this.http({
      url: `${this.baseUrl}/space`,
      method: "POST",
      data: {
        space_name: t,
        space_desc: "",
        space_icon: ""
      },
      params: {
        init_folder: !1
      }
    }).then((s) => {
      this.http({
        url: `${this.baseUrl}/space/${s.space_id}/folder`,
        method: "PUT",
        data: {
          space_id: s.space_id,
          parent_id: "-root",
          folder_name: this.t("BaseSaveToWorkspace.FolderSelector.newFolderName"),
          folder_desc: ""
        }
      }).then((a) => {
        c.assign(a, {
          isNewCreate: !0
        }), c.assign(s, {
          isNew: !0,
          isNewCreate: !0,
          expand: !0,
          folderTreeData: [a]
        }), this.folderSelector.workspaceGroupList[0].workspaces.unshift(s);
        const r = c.get(this.folderSelector, "workspaceGroupList[0].workspaces[0]");
        this.isFolderDisabled({ currentWorkspace: r, folder: a }) || this.selectWorkspace(r).then(() => {
          this.selectFolder(a);
        }).catch(() => {
        }), this.editWorkspace(r);
      }).catch((a) => {
        this.onError(a, { module: "FolderSelector" });
      });
    }).catch((s) => {
      this.onError(s, { module: "FolderSelector" });
    });
  }
  async selectWorkspace(e) {
    if (this.folderSelector.initFolderScroll = !1, this.folderSelector.selectedWorkspace = e, e) {
      const t = c.find(this.folderSelector.workspaceGroupList, { type: this.getWorkspaceGroupType(e) });
      if (t.expand || (t.expand = !0), !e.folder_info_simples && !e.isLoading) {
        const { lastFolderSearchKeywords: s } = this.folderSelector;
        if (await this.fetchFolders({ workspace: e, folder_search_name: s }), !c.isEqual(e, this.folderSelector.selectedWorkspace))
          throw new Error();
      }
    }
  }
  selectFolder(e) {
    this.folderSelector.selectedFolder = e;
  }
  // RangeSelector
  get disabledAllType() {
    return c.includes(this.rangeSelector.disabledTypes, "ALL");
  }
  getDisabledAllTypeTooltip() {
    if (!this.disabledAllType || this.folderSelector.loading)
      return "";
    const {
      type: e,
      formatNumber: t,
      rangeSelector: { addLimit: s },
      t: a
    } = this;
    return a(`BaseSaveToWorkspace.${e}.RangeSelector.error.rangeError`, { limit: t(s) });
  }
  get disabledRangeType() {
    return c.includes(this.rangeSelector.disabledTypes, "RANGE");
  }
  verifyRange() {
    const { enableRange: e } = this, {
      from: t,
      to: s,
      addLimit: a,
      maxInputLimit: r,
      selectedType: i
    } = this.rangeSelector;
    if (this.rangeSelector.error = null, !e || i === "ALL")
      return !0;
    if (!t || !s || s < t)
      return this.rangeSelector.error = this.t(`BaseSaveToWorkspace.${this.type}.RangeSelector.error.invalidError`), !1;
    if (t > r || s > r)
      return this.rangeSelector.error = this.t(
        `BaseSaveToWorkspace.${this.type}.RangeSelector.error.overMaxCountError`,
        { limit: this.formatNumber(r) }
      ), !1;
    const l = this.rangeSelector.countMax;
    return t > l || s > l ? (this.rangeSelector.error = this.t(
      `BaseSaveToWorkspace.${this.type}.RangeSelector.error.invalidError`
    ), !1) : s - t + 1 > l ? (this.rangeSelector.error = this.t(
      `BaseSaveToWorkspace.${this.type}.RangeSelector.error.invalidError`
    ), !1) : s - t + 1 > a ? (this.rangeSelector.error = this.t(
      `BaseSaveToWorkspace.${this.type}.RangeSelector.error.rangeError`,
      { limit: this.formatNumber(a) }
    ), !1) : !0;
  }
}
const J = {
  name: "SaveToWorkspaceWorkspaceItem",
  components: {
    PtIcon: w
  },
  inject: ["service"],
  props: {
    workspace: {
      type: Object,
      required: !0
    }
  },
  computed: {
    isCurrentWorkspace() {
      return c.get(this.service.folderSelector.selectedWorkspace, "space_id") === c.get(this.workspace, "space_id");
    },
    countText() {
      return this.service.getWorkspaceElementsCountString(this.workspace);
    },
    titleText() {
      const { workspace: o, countText: e } = this;
      return `${o.space_name} ${e}`;
    },
    isWorkspaceNameError() {
      return !0;
    }
  },
  watch: {
    "workspace.isEditing": {
      handler() {
        this.$nextTick(() => {
          const o = c.get(this, "$refs.workspaceNameInputRef");
          o && (o.focus(), o.select());
        });
      },
      immediate: !0
    }
  },
  mounted() {
    this.$nextTick(() => {
      const { folderSelector: o } = this.service;
      return o.initWorkspaceScroll || this.workspace !== o.selectedWorkspace ? !1 : (o.initWorkspaceScroll = !0, B(this.$el), !0);
    });
  },
  methods: {
    onKeypressEnter() {
      const o = c.get(this, "$refs.workspaceNameInputRef");
      o && o.blur();
    },
    selectWorkspace(o) {
      return this.service.selectWorkspace(o).then(() => {
        this.service.selectFolder(c.get(o, "folderTreeData[0]"));
      }).catch(() => {
      });
    },
    async addFolder(o) {
      this.isCurrentWorkspace || await this.selectWorkspace(o), setTimeout(() => {
        this.service.addFolder({
          workspace: o,
          parentFolder: null
        });
      }, 100);
    }
  }
}, F = (o, e) => {
  const t = o.__vccOpts || o;
  for (const [s, a] of e)
    t[s] = a;
  return t;
}, X = ["data-space-id"], Y = { class: "workspace-name-container" }, Z = ["disabled"], ee = ["title"], te = ["title"], re = { class: "workspace-item-action-pane" };
function se(o, e, t, s, a, r) {
  const i = y("PtIcon");
  return n(), p("div", {
    class: _(["s2w-workspace-item", {
      "is-current": r.isCurrentWorkspace,
      "is-editing": t.workspace.isEditing
    }])
  }, [
    d("div", {
      ref: "workspaceInfoRef",
      class: "s2w-workspace-item-info",
      "data-space-id": t.workspace.space_id,
      onClick: e[7] || (e[7] = (l) => r.selectWorkspace(t.workspace))
    }, [
      S(i, {
        class: "workspace-icon",
        style: { "font-size": "24px" },
        icon: r.service.getWorkspaceIcon(t.workspace)
      }, null, 8, ["icon"]),
      d("div", Y, [
        t.workspace.isEditing ? (n(), p("div", {
          key: 0,
          class: "workspace-name-editor",
          onClick: e[3] || (e[3] = T(() => {
          }, ["stop"]))
        }, [
          I(d("input", {
            ref: "workspaceNameInputRef",
            "onUpdate:modelValue": e[0] || (e[0] = (l) => t.workspace.space_name = l),
            class: _({
              error: !r.service.isWorkspaceNameValid(t.workspace)
            }),
            type: "text",
            maxlength: "40",
            disabled: t.workspace.isUpdating,
            onKeypress: e[1] || (e[1] = R((...l) => r.onKeypressEnter && r.onKeypressEnter(...l), ["enter"])),
            onBlur: e[2] || (e[2] = (l) => r.service.finishEditWorkspace(t.workspace))
          }, null, 42, Z), [
            [A, t.workspace.space_name]
          ])
        ])) : (n(), p(v, { key: 1 }, [
          d("div", {
            class: "workspace-name",
            title: r.titleText,
            onDblclick: e[4] || (e[4] = (l) => r.service.editWorkspace(t.workspace))
          }, h(t.workspace.space_name), 41, ee),
          d("div", {
            title: r.titleText,
            class: "workspace-elements-count"
          }, h(r.countText), 9, te)
        ], 64))
      ]),
      d("div", re, [
        r.service.hasEditWorkspacePermission(t.workspace) ? (n(), g(i, {
          key: 0,
          class: "workspace-item-action-item",
          style: { "font-size": "24px" },
          icon: "SolidEdit",
          onClick: e[5] || (e[5] = T((l) => r.service.editWorkspace(t.workspace), ["stop"]))
        })) : m("", !0),
        r.service.hasAddWorkspaceFolderPermission(t.workspace) ? (n(), g(i, {
          key: 1,
          class: "workspace-item-action-item",
          style: { "font-size": "24px" },
          icon: "SolidFolderAdd",
          onClick: e[6] || (e[6] = T((l) => r.addFolder(t.workspace), ["stop"]))
        })) : m("", !0)
      ])
    ], 8, X)
  ], 2);
}
const oe = /* @__PURE__ */ F(J, [["render", se]]), ae = {
  name: "FolderTreeItem",
  components: {
    PtIcon: w,
    ElTooltip: j
  },
  inject: ["service"],
  props: {
    level: {
      type: Number,
      required: !0
    },
    folder: {
      type: Object,
      required: !0
    },
    parentFolder: {
      type: Object,
      default: null
    }
  },
  computed: {
    isLastSaved() {
      return this.folder.folder_id === this.service.folderSelector.latestFolderId;
    },
    workspace() {
      return this.service.folderSelector.selectedWorkspace;
    },
    countText() {
      const { folder: o, workspace: e, service: t } = this;
      return t.getFolderElementsCountString({ workspace: e, folder: o });
    },
    titleText() {
      const { folder: o, countText: e } = this;
      return `${o.folder_name} ${e}`;
    },
    paddingStyle() {
      return {
        paddingLeft: `${25 * this.level + 10 || 10}px`
      };
    }
  },
  watch: {
    "folder.isEditing": {
      handler() {
        this.$nextTick(() => {
          const o = c.get(this, "$refs.folderNameInputRef");
          o && (o.focus(), o.select());
        });
      },
      immediate: !0
    }
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        const { folderSelector: o } = this.service;
        return o.initFolderScroll || this.folder !== o.selectedFolder ? !1 : (o.initFolderScroll = !0, B(this.$el), !0);
      });
    }, 0);
  },
  methods: {
    onKeypressEnter() {
      const o = c.get(this, "$refs.folderNameInputRef");
      o && o.blur();
    },
    selectFolder() {
      const { workspace: o, folder: e } = this;
      this.service.isFolderDisabled({ workspace: o, folder: e }) || this.service.selectFolder(e);
    }
  }
}, le = { class: "s2w-folder-tree-item" }, ie = ["data-folder-id"], ne = { class: "folder-name-container" }, ce = ["disabled"], de = ["title", "innerHTML"], ue = ["title"], pe = { class: "folder-item-action-pane" }, fe = { class: "folder-item-status-tag" }, he = { key: 0 };
function me(o, e, t, s, a, r) {
  const i = y("PtIcon"), l = y("el-tooltip"), f = y("FolderTreeItem", !0);
  return n(), p("div", le, [
    S(l, {
      effect: "light",
      placement: "top",
      "popper-class": "pt-ui-tooltip",
      "visible-arrow": !1,
      content: r.service.folderDisabledMsg({ workspace: r.workspace, folder: t.folder }),
      disabled: !r.service.folderDisabledMsg({ workspace: r.workspace, folder: t.folder })
    }, {
      default: L(() => [
        d("div", {
          class: _(["s2w-folder-tree-item-folder-info", {
            "is-current": r.service.folderSelector.selectedFolder === t.folder,
            "is-editing": t.folder.isEditing,
            "is-last-saved": r.isLastSaved,
            disabled: r.service.isFolderDisabled({ workspace: r.workspace, folder: t.folder })
          }]),
          style: z(r.paddingStyle),
          "data-folder-id": t.folder.folder_id,
          onClick: e[8] || (e[8] = (...u) => r.selectFolder && r.selectFolder(...u))
        }, [
          S(i, {
            class: _(["folder-expand-icon", {
              "has-children": t.folder.children && t.folder.children.length
            }]),
            style: { "font-size": "24px" },
            icon: t.folder.expand ? "SolidDropdownOpen" : "SolidDropdownRight",
            onClick: e[0] || (e[0] = T((u) => r.service.toggleFolderExpand({ workspace: r.workspace, folder: t.folder }), ["stop"]))
          }, null, 8, ["class", "icon"]),
          S(i, {
            class: "folder-icon",
            style: { "font-size": "24px" },
            icon: r.service.getFolderIcon({ workspace: r.workspace, folder: t.folder })
          }, null, 8, ["icon"]),
          d("div", ne, [
            t.folder.isEditing ? (n(), p("div", {
              key: 0,
              class: "folder-name-editor",
              onClick: e[4] || (e[4] = T(() => {
              }, ["stop"]))
            }, [
              I(d("input", {
                ref: "folderNameInputRef",
                "onUpdate:modelValue": e[1] || (e[1] = (u) => t.folder.folder_name = u),
                class: _({
                  error: !r.service.isFolderNameValid({ workspace: r.workspace, folder: t.folder })
                }),
                type: "text",
                maxlength: "40",
                disabled: t.folder.isUpdating,
                onKeypress: e[2] || (e[2] = R((...u) => r.onKeypressEnter && r.onKeypressEnter(...u), ["enter"])),
                onBlur: e[3] || (e[3] = (u) => r.service.finishEditFolder({ workspace: r.workspace, folder: t.folder, parentFolder: t.parentFolder }))
              }, null, 42, ce), [
                [A, t.folder.folder_name]
              ])
            ])) : (n(), p(v, { key: 1 }, [
              d("div", {
                class: "folder-name",
                title: r.titleText,
                onDblclick: e[5] || (e[5] = (u) => r.service.editFolder({ workspace: r.workspace, folder: t.folder })),
                innerHTML: r.service.renderFolderName({ workspace: r.workspace, folder: t.folder })
              }, null, 40, de),
              d("div", {
                title: r.titleText,
                class: "folder-elements-count"
              }, h(r.countText), 9, ue)
            ], 64))
          ]),
          d("div", pe, [
            r.service.hasEditFolderPermission({ workspace: r.workspace, folder: t.folder }) ? (n(), g(i, {
              key: 0,
              class: "folder-item-action-item",
              style: { "font-size": "24px" },
              icon: "SolidEdit",
              onClick: e[6] || (e[6] = T((u) => r.service.editFolder({ workspace: r.workspace, folder: t.folder }), ["stop"]))
            })) : m("", !0),
            r.service.hasAddSubFolderPermission({ workspace: r.workspace, folder: t.folder, level: t.level }) ? (n(), g(i, {
              key: 1,
              class: "folder-item-action-item",
              style: { "font-size": "24px" },
              icon: "SolidFolderAdd",
              onClick: e[7] || (e[7] = T((u) => r.service.addFolder({
                workspace: r.workspace,
                parentFolder: t.folder
              }), ["stop"]))
            })) : m("", !0),
            d("div", fe, h(o.$t(`BaseSaveToWorkspace.FolderSelector.lastFlag.${r.service.folderSelector.latestType}`)), 1)
          ])
        ], 14, ie)
      ]),
      _: 1
    }, 8, ["content", "disabled"]),
    t.level <= r.service.folderSelector.folderLoopProtectionFlag && t.folder.expand && t.folder.children ? (n(), p("div", he, [
      (n(!0), p(v, null, E(t.folder.children, (u) => (n(), g(f, {
        key: u.folder_id,
        folder: u,
        "parent-folder": t.folder,
        level: t.level + 1
      }, null, 8, ["folder", "parent-folder", "level"]))), 128))
    ])) : m("", !0)
  ]);
}
const ge = /* @__PURE__ */ F(ae, [["render", me]]), Se = {
  name: "SaveToWorkspaceFolderTree",
  components: {
    FolderTreeItem: ge
  },
  inject: ["service"],
  props: {
    folders: {
      type: Array,
      required: !0
    }
  }
}, ye = { class: "pz-save-to-workspace-folder-tree" };
function ve(o, e, t, s, a, r) {
  const i = y("FolderTreeItem");
  return n(), p("div", ye, [
    (n(!0), p(v, null, E(t.folders, (l) => (n(), g(i, {
      key: l.folder_id,
      folder: l,
      level: 0
    }, null, 8, ["folder"]))), 128))
  ]);
}
const ke = /* @__PURE__ */ F(Se, [["render", ve]]), _e = {
  name: "SaveToWorkspaceWorkspaceList",
  components: {
    WorkspaceItem: oe,
    FolderTree: ke,
    PtIcon: w
  },
  inject: ["service"],
  computed: {
    selectedWorkspace() {
      return this.service.folderSelector.selectedWorkspace;
    },
    groups() {
      return this.service.folderSelector.workspaceGroupList;
    },
    isFolderLoading() {
      return c.get(this.selectedWorkspace, "isLoading");
    }
  }
}, be = { class: "s2w-workspace-container" }, Te = { class: "s2w-workspace-group-list" }, we = ["onClick"], Fe = { class: "s2w-workspace-group-item-pane" }, Ce = {
  key: 0,
  class: "s2w-workspace-folder-list"
}, We = {
  key: 0,
  class: "loading-pane"
}, Le = {
  key: 1,
  class: "no-data-pane"
};
function Ee(o, e, t, s, a, r) {
  const i = y("PtIcon"), l = y("WorkspaceItem"), f = y("FolderTree");
  return n(), p("div", be, [
    d("div", Te, [
      (n(!0), p(v, null, E(r.groups, (u) => (n(), p(v, null, [
        u.workspaces.length ? (n(), p("div", {
          key: u.type,
          class: "s2w-workspace-group-item",
          onClick: (k) => u.expand = !u.expand
        }, [
          d("div", Fe, [
            S(i, {
              class: "s2w-workspace-group-expand-icon",
              style: { "font-size": "24px" },
              icon: u.expand ? "SolidDropdownOpen" : "SolidDropdownRight"
            }, null, 8, ["icon"]),
            d("span", null, h(o.$t(`BaseSaveToWorkspace.FolderSelector.workspaceGroupType.${u.type}`)), 1)
          ]),
          u.expand ? (n(), p("div", {
            key: 0,
            class: "s2w-workspace-group-workspace-item",
            onClick: e[0] || (e[0] = T(() => {
            }, ["stop"]))
          }, [
            (n(!0), p(v, null, E(u.workspaces, (k) => (n(), g(l, {
              key: k.space_id,
              workspace: k
            }, null, 8, ["workspace"]))), 128))
          ])) : m("", !0)
        ], 8, we)) : m("", !0)
      ], 64))), 256))
    ]),
    r.selectedWorkspace ? (n(), p("div", Ce, [
      r.isFolderLoading ? (n(), p("div", We, [
        S(i, {
          icon: "SolidLoadingBars",
          style: { "font-size": "48px" }
        })
      ])) : (n(), p(v, { key: 1 }, [
        r.selectedWorkspace.folderTreeData && r.selectedWorkspace.folderTreeData.length ? (n(), g(f, {
          key: 0,
          folders: r.selectedWorkspace.folderTreeData
        }, null, 8, ["folders"])) : (n(), p("div", Le, [
          S(i, {
            icon: "SolidNoDataTip",
            style: { "font-size": "40px" }
          }),
          d("div", null, h(o.$t("BaseSaveToWorkspace.FolderSelector.noData.folder")), 1)
        ]))
      ], 64))
    ])) : m("", !0)
  ]);
}
const Pe = /* @__PURE__ */ F(_e, [["render", Ee]]), Ie = {
  name: "SaveToWorkspaceFolderSelector",
  components: {
    PtIcon: w,
    WorkspaceList: Pe
  },
  inject: ["service"],
  computed: {
    folderSelector() {
      return c.get(this, "service.folderSelector");
    }
  },
  methods: {
    clearSearchInput() {
      this.folderSelector.folderSearchKeywords = "", this.onKeywordsInput();
    },
    onKeywordsInput() {
      !this.folderSelector.folderSearchKeywords && this.folderSelector.lastFolderSearchKeywords && this.service.fetchWorkspaces();
    },
    onKeypressEnter() {
      this.folderSelector.folderSearchKeywords && this.service.fetchWorkspaces();
    }
  }
}, Re = { class: "s2w-workspace-folder-selector-container" }, Ae = { class: "s2w-select-folder-label" }, xe = { class: "selector-label" }, Ne = { class: "s2w-workspace-folder-selector" }, Me = {
  key: 0,
  class: "s2w-search-input"
}, Ue = ["placeholder"], De = {
  key: 0,
  class: "loading-pane"
}, Be = {
  key: 2,
  class: "no-data-pane"
};
function Ge(o, e, t, s, a, r) {
  const i = y("PtIcon"), l = y("WorkspaceList");
  return n(), p("div", Re, [
    d("div", Ae, [
      d("span", xe, h(o.$t("BaseSaveToWorkspace.FolderSelector.label")), 1)
    ]),
    d("div", Ne, [
      r.folderSelector.enableFoldersSearch ? (n(), p("div", Me, [
        I(d("input", {
          "onUpdate:modelValue": e[0] || (e[0] = (f) => r.folderSelector.folderSearchKeywords = f),
          placeholder: o.$t("BaseSaveToWorkspace.FolderSelector.searchFolderInputPlaceholder"),
          maxlength: "40",
          onKeypress: e[1] || (e[1] = R((...f) => r.onKeypressEnter && r.onKeypressEnter(...f), ["enter"])),
          onInput: e[2] || (e[2] = (...f) => r.onKeywordsInput && r.onKeywordsInput(...f))
        }, null, 40, Ue), [
          [
            A,
            r.folderSelector.folderSearchKeywords,
            void 0,
            { trim: !0 }
          ]
        ]),
        r.folderSelector.folderSearchKeywords ? (n(), g(i, {
          key: 0,
          class: "clear-btn",
          icon: "SolidCloseMedium",
          style: { "font-size": "16px" },
          onClick: e[3] || (e[3] = (f) => r.clearSearchInput())
        })) : m("", !0),
        S(i, {
          class: "search-btn",
          icon: "SolidSearchLeft",
          style: { "font-size": "24px" },
          onClick: r.onKeypressEnter
        }, null, 8, ["onClick"])
      ])) : m("", !0),
      d("div", null, [
        r.folderSelector.loading ? (n(), p("div", De, [
          S(i, {
            icon: "SolidLoadingBars",
            style: { "font-size": "48px" }
          })
        ])) : r.folderSelector.workspaceList && r.folderSelector.workspaceList.length ? (n(), g(l, { key: 1 })) : (n(), p("div", Be, [
          S(i, {
            icon: "SolidNoDataTip",
            style: { "font-size": "40px" }
          }),
          d("div", null, h(r.folderSelector.lastFolderSearchKeywords ? o.$t("BaseSaveToWorkspace.FolderSelector.noData.search") : o.$t("BaseSaveToWorkspace.FolderSelector.noData.workspace")), 1)
        ]))
      ]),
      d("div", {
        class: "add-workspace-btn",
        onClick: e[4] || (e[4] = (f) => r.service.addWorkspace())
      }, [
        S(i, {
          icon: "SolidAddMedium",
          style: { "font-size": "24px" }
        }),
        P(" " + h(o.$t("BaseSaveToWorkspace.FolderSelector.addWorkspace")), 1)
      ])
    ])
  ]);
}
const $ = /* @__PURE__ */ F(Ie, [["render", Ge]]);
class lr extends G {
  constructor() {
    super(), this.type = "PAPER";
  }
  getFolderIcon() {
    return "SolidFolderClosed2";
  }
  getWorkspaceElementsCountString(e) {
    const { total_paper_count: t = 0 } = e;
    return `(${this.formatNumber(t)})`;
  }
  getFolderElementsCountString({ folder: e }) {
    const { paper_count: t = 0 } = e;
    return `(${this.formatNumber(t)})`;
  }
  getSubmitApiConfig() {
    const { selectedWorkspace: { space_id: e }, selectedFolder: { folder_id: t } } = this.folderSelector;
    return {
      url: `${this.baseUrl}/space/${e}/folder/${t}/save-papers`,
      method: "POST"
    };
  }
}
const b = {
  LOADING: -1,
  ERROR: -2
}, U = "SAVE_TO_WORKSPACE:AUTO_UPDATE";
class ir extends G {
  constructor() {
    super(), this.type = "PATENT", this.searchGroupMode = {
      searchMode: "publication",
      // 同族库(family)  公开库(publication)
      groupMode: "EXTEND",
      // 分组类型 默认为 ALL
      selectedGroupCounts: 0
      // 选中同族背后实际专利数量
    }, this.searchGroupModeRange = 5e3, this.familyRangeCount = 0, this.allGroupCounts = 0, this.familyRangeCountLoading = !1, this.allGroupCountLoading = !1, this.enableAutoUpdate = !1, this.enableFamily = !1, this.showRangeTip = !0, this.rangeSelector = {
      ...this.rangeSelector,
      maxInputLimit: 1e5,
      groupCounts: 0,
      // 同族分组后的数量
      family: {
        enable: !1,
        selected: null,
        init: !1,
        get ready() {
          return this.selected ? !(this.selected.loading || this.selected.count === b.ERROR) : !0;
        },
        familyExpansions: [{
          key: "apno_count",
          value: "APNO",
          label: "selectedPatentsApno",
          count: b.LOADING,
          get loading() {
            return this.count === b.LOADING;
          }
        }, {
          key: "simple_count",
          value: "SIMPLE",
          label: "selectedPatentsSimple",
          count: b.LOADING,
          get loading() {
            return this.count === b.LOADING;
          }
        }, {
          key: "inpadoc_count",
          value: "INPADOC",
          label: "selectedPatentsINPADOC",
          count: b.LOADING,
          get loading() {
            return this.count === b.LOADING;
          }
        }, {
          key: "extend_count",
          value: "EXTEND",
          label: "selectedPatentsExtended",
          count: b.LOADING,
          get loading() {
            return this.count === b.LOADING;
          }
        }]
      }
    }, this.autoUpdate = {
      q: "",
      efq: "",
      enable: this.getAutoUpdateStorageStatus()
    };
  }
  get familyMode() {
    return this.searchGroupMode.searchMode === "family";
  }
  get groupMode() {
    return this.searchGroupMode.groupMode !== "ALL";
  }
  getFolderIcon({ folder: e }) {
    return e.folder_auto_update ? "SolidAutoFolder" : "SolidFolderClosed2";
  }
  isFolderDisabled({ folder: e }) {
    return this.enableAutoUpdate ? e.folder_auto_update && this.autoUpdate.enable : !1;
  }
  selectFolder(e) {
    super.selectFolder(e), this.enableAutoUpdate && e && this.identifyAutoUpdateStatus();
  }
  getWorkspaceElementsCountString(e) {
    const { total_patent_count: t = 0 } = e;
    return `(${this.formatNumber(t)})`;
  }
  getFolderElementsCountString({ folder: e }) {
    const { patent_count: t = 0 } = e;
    return `(${this.formatNumber(t)})`;
  }
  getSubmitApiConfig() {
    const { selectedWorkspace: { space_id: e }, selectedFolder: { folder_id: t } } = this.folderSelector;
    return {
      url: `${this.baseUrl}/space/${e}/folder/${t}/patents/v2`,
      method: "PUT"
    };
  }
  getDisabledAllTypeTooltip() {
    if (!this.disabledAllType || this.folderSelector.loading)
      return "";
    const {
      type: e,
      formatNumber: t,
      rangeSelector: { maxPerFolder: s },
      t: a
    } = this;
    return a(
      `BaseSaveToWorkspace.${e}.RangeSelector.error.disabledSelectAllError`,
      { limit: t(s) }
    );
  }
  isSubmitButtonDisabled() {
    const { rangeSelector: { family: e } } = this;
    return this.enableFamily && e.enable && !e.ready || this.familyRangeCountLoading || this.allGroupCountLoading ? !0 : super.isSubmitButtonDisabled();
  }
  getCurrentParams() {
    const e = super.getCurrentParams(), {
      enableFamily: t,
      enableAutoUpdate: s,
      rangeSelector: a,
      autoUpdate: r,
      searchGroupMode: i
    } = this, {
      family: l,
      selectedType: f
    } = a, { searchMode: u } = i;
    return t && l.enable && (e.familyExpansion = l.selected.value, e.isAll && (e.to = l.selected.count, e.counts = l.selected.count)), this.familyMode && (e.search_mode = u), this.familyMode && this.groupMode && (f === "RANGE" ? e.counts = this.searchGroupMode.selectedGroupCounts || this.familyRangeCount : e.counts = this.searchGroupMode.selectedGroupCounts || this.allGroupCounts), s && r.enable && (e.autoUpdate = !0), e;
  }
  initFolderSelector() {
    this.fetchWorkspaces().then(() => {
      if (!this.folderSelector.response)
        return;
      const e = c.get(this.folderSelector, "response.addLimit"), t = c.get(this.folderSelector, "response.maxPerFolder");
      this.rangeSelector.addLimit = e, this.rangeSelector.maxPerFolder = t, this.rangeSelector.disabledTypes = [];
      const {
        maxInputLimit: s,
        allCounts: a,
        groupCounts: r,
        to: i
      } = this.rangeSelector, { selectedGroupCounts: l } = this.searchGroupMode;
      this.familyMode && this.groupMode ? ((r || a) > t ? (this.rangeSelector.selectedType = "RANGE", this.rangeSelector.disabledTypes = ["ALL"]) : l === 0 && this.getAllGroupCounts(t), l === 0 && this.getFamilyRangeCount()) : (this.rangeSelector.countMax = r || a, a > t && (this.rangeSelector.selectedType = "RANGE", this.rangeSelector.disabledTypes = ["ALL"])), this.rangeSelector.max = Math.min(this.rangeSelector.countMax, s, e), this.familyMode && this.groupMode ? this.rangeSelector.to = i : this.rangeSelector.to = this.rangeSelector.max, this.verifyRange();
    });
  }
  // 高级 - 自动收录
  toggleAutoUpdate() {
    const { autoUpdate: e } = this, t = !e.enable;
    e.enable = t, this.setAutoUpdateStorageStatus(t);
  }
  // 识别自动收录状态
  identifyAutoUpdateStatus() {
    const e = this.rangeSelector.selectedType === "RANGE", t = this.rangeSelector.family.enable, s = c.get(this.folderSelector, "selectedFolder.folder_auto_update");
    e || t || s ? this.autoUpdate.enable = !1 : this.autoUpdate.enable = this.getAutoUpdateStorageStatus();
  }
  // 高级 - 同族
  generateFamilyExpansionParams() {
    return Promise.reject(new Error({
      _error_msg: "Please implementation method <generateFamilyExpansionParams>"
    }));
  }
  handleFamilyError() {
    const { family: e } = this.rangeSelector, { selected: t } = e;
    if (!t)
      return !1;
    const { count: s } = t;
    return s === b.ERROR && this.onToastError({ message: this.t("BaseSaveToWorkspace.RangeSelector.family.error") }), !0;
  }
  async initFamily() {
    const { family: e } = this.rangeSelector, { familyExpansions: t } = e;
    if (e.init || !e.enable)
      return;
    e.init = !0, e.selected = e.familyExpansions[0], e.promiseUID = c.uniqueId();
    const { promiseUID: s } = e;
    let a = {};
    try {
      a = await this.generateFamilyExpansionParams(this.getCurrentParams());
    } catch (r) {
      this.onError(r, { module: "Family" });
      return;
    }
    c.forEach(t, (r) => {
      this.http({
        url: `${this.baseUrl}/family-expansion-count`,
        method: "POST",
        data: {
          ...a,
          family_expansion: r.value
        }
      }).then((i) => {
        s === e.promiseUID && (r.count = i >= 0 ? i : b.ERROR);
      }).catch(() => {
        s === e.promiseUID && (r.count = b.ERROR, this.handleFamilyError());
      });
    });
  }
  async getFamilyRangeCount() {
    if (!this.verifyRange() || !this.familyMode || this.familyMode && !this.groupMode)
      return;
    this.familyRangeCountLoading = !0;
    const e = {
      start: this.rangeSelector.from,
      end: this.rangeSelector.to,
      save_all: !1
    }, t = await this.generateSubmitSaveToWorkspaceParams(this.getCurrentParams());
    t.auto = !1, t.range_params = c.assign({}, t.range_params, e), delete t.range_params.dbs, this.http({
      url: `${this.baseUrl}/family-base/count`,
      method: "POST",
      data: {
        ...t
      }
    }).then((s) => {
      this.familyRangeCount = s;
    }).catch(() => {
      this.familyRangeCount = 0;
    }).finally(() => {
      this.familyRangeCountLoading = !1;
    });
  }
  async getAllGroupCounts(e) {
    if (!this.familyMode || this.familyMode && !this.groupMode || !this.enableRange)
      return;
    this.allGroupCountLoading = !0;
    const t = await this.generateSubmitSaveToWorkspaceParams(this.getCurrentParams());
    t.auto = !1, t.range_params.save_all = !0, delete t.range_params.dbs, this.http({
      url: `${this.baseUrl}/family-base/count`,
      method: "POST",
      data: {
        ...t
      }
    }).then((s) => {
      this.allGroupCounts = s || 1, this.allGroupCounts > e && (this.rangeSelector.selectedType = "RANGE", this.rangeSelector.disabledTypes = ["ALL"]);
    }).catch(() => {
      this.allGroupCounts = 0;
    }).finally(() => {
      this.allGroupCountLoading = !1;
    });
  }
  init() {
    this.initFolderSelector();
  }
  selectFamilyExpansion(e) {
    this.initFamily(), this.rangeSelector.family.selected = e, this.handleFamilyError();
  }
  toggleFamily() {
    const { rangeSelector: { family: e }, enableAutoUpdate: t } = this, s = !e.enable;
    e.enable = s, t && this.identifyAutoUpdateStatus(), this.initFamily();
  }
  getAutoUpdateStorageStatus() {
    return localStorage.getItem(U) === "true";
  }
  setAutoUpdateStorageStatus(e) {
    localStorage.setItem(U, e);
  }
  verifyRange() {
    const { enableRange: e } = this, {
      from: t,
      to: s,
      addLimit: a,
      maxInputLimit: r,
      selectedType: i,
      allCounts: l,
      groupCounts: f
    } = this.rangeSelector;
    if (this.rangeSelector.error = null, !e || i === "ALL")
      return !0;
    if (!t || !s || s < t)
      return this.rangeSelector.error = this.t(`BaseSaveToWorkspace.${this.type}.RangeSelector.error.invalidError`), !1;
    if (t > r || s > r)
      return this.rangeSelector.error = this.t(
        `BaseSaveToWorkspace.${this.type}.RangeSelector.error.overMaxCountError`,
        { limit: this.formatNumber(r) }
      ), !1;
    let u = this.rangeSelector.countMax;
    if (this.familyMode && this.groupMode && (u = f || l), t > u || s > u)
      return this.rangeSelector.error = this.t(
        `BaseSaveToWorkspace.${this.type}.RangeSelector.error.invalidError`
      ), !1;
    if (s - t + 1 > u)
      return this.rangeSelector.error = this.t(
        `BaseSaveToWorkspace.${this.type}.RangeSelector.error.invalidError`
      ), !1;
    if (this.familyMode && this.groupMode) {
      if (s - t + 1 > this.searchGroupModeRange)
        return this.rangeSelector.error = this.t(
          `BaseSaveToWorkspace.${this.type}.RangeSelector.error.familyRangeError`,
          { limit: this.formatNumber(this.searchGroupModeRange) }
        ), !1;
    } else if (s - t + 1 > a)
      return this.rangeSelector.error = this.t(
        `BaseSaveToWorkspace.${this.type}.RangeSelector.error.rangeError`,
        { limit: this.formatNumber(a) }
      ), !1;
    return !0;
  }
}
const $e = {
  name: "FamilySelector",
  components: {
    PtIcon: w
  },
  inject: ["service"],
  data() {
    return {
      showFamilyPopper: !1
    };
  },
  computed: {
    enable() {
      return this.service.rangeSelector.family.enable;
    },
    disabled() {
      const { rangeSelector: { selectedType: o }, disabledAllType: e, enableRange: t } = this.service;
      return !!(o === "RANGE" || t && e);
    },
    familyExpansions() {
      return this.service.rangeSelector.family.familyExpansions;
    },
    selected() {
      return this.service.rangeSelector.family.selected;
    }
  },
  created() {
    this.closeFamilyPopper = () => {
      this.showFamilyPopper = !1;
    }, document.addEventListener("mousedown", this.closeFamilyPopper);
  },
  beforeUnmount() {
    document.removeEventListener("mousedown", this.closeFamilyPopper);
  },
  methods: {
    selectFamilyExpansion(o) {
      this.service.selectFamilyExpansion(o), this.showFamilyPopper = !1;
    },
    toggleFamily() {
      return this.disabled ? !1 : (this.service.toggleFamily(), !0);
    }
  }
}, Oe = { class: "s2w-family-desc" }, ze = {
  key: 0,
  class: "s2w-family-selector"
}, Ke = { class: "s2w-family-selector-label" }, qe = { key: 1 }, Ve = ["onClick"], je = { class: "s2w-family-selector-item-info" }, He = { class: "s2w-family-selector-label" }, Qe = { key: 1 };
function Je(o, e, t, s, a, r) {
  const i = y("PtIcon");
  return n(), p("div", {
    class: _(["s2w-family-selector-container", {
      disabled: r.disabled
    }])
  }, [
    d("div", {
      class: _(["s2w-family-switch", { enable: r.enable }]),
      onClick: e[0] || (e[0] = (l) => r.toggleFamily())
    }, null, 2),
    d("div", Oe, h(o.$t("BaseSaveToWorkspace.RangeSelector.family.label")), 1),
    r.enable ? (n(), p("div", ze, [
      d("div", {
        class: _(["s2w-family-selector-current", {
          active: a.showFamilyPopper
        }]),
        onMousedown: e[1] || (e[1] = T(() => {
        }, ["stop"])),
        onClick: e[2] || (e[2] = T((l) => a.showFamilyPopper = !a.showFamilyPopper, ["stop"]))
      }, [
        r.selected ? (n(), p(v, { key: 0 }, [
          d("div", Ke, h(o.$t(`BaseSaveToWorkspace.RangeSelector.family.types.${r.selected.value}`)), 1),
          r.selected.loading ? (n(), g(i, {
            key: 0,
            icon: "SolidLoadingBars",
            style: { "font-size": "24px" }
          })) : r.selected.count >= 0 ? (n(), p("div", qe, " (" + h(r.service.formatNumber(r.selected.count)) + ") ", 1)) : m("", !0)
        ], 64)) : m("", !0),
        S(i, {
          style: { "font-size": "24px" },
          icon: a.showFamilyPopper ? "SolidDropdownClose" : "SolidDropdownOpen"
        }, null, 8, ["icon"])
      ], 34),
      a.showFamilyPopper ? (n(), p("div", {
        key: 0,
        class: "s2w-family-selector-popper",
        onMousedown: e[3] || (e[3] = T(() => {
        }, ["stop"]))
      }, [
        (n(!0), p(v, null, E(r.familyExpansions, (l) => (n(), p("div", {
          key: l.value,
          class: _(["s2w-family-selector-item", { current: r.selected === l }]),
          onClick: (f) => r.selectFamilyExpansion(l)
        }, [
          d("div", je, [
            d("div", He, h(o.$t(`BaseSaveToWorkspace.RangeSelector.family.types.${l.value}`)), 1),
            l.loading ? (n(), g(i, {
              key: 0,
              icon: "SolidLoadingBars",
              style: { "font-size": "24px" }
            })) : r.selected.count >= 0 ? (n(), p("div", Qe, " (" + h(r.service.formatNumber(l.count)) + ") ", 1)) : m("", !0)
          ]),
          S(i, {
            class: "s2w-family-selector-item-tick",
            icon: "SolidTick",
            style: { "font-size": "24px" }
          })
        ], 10, Ve))), 128))
      ], 32)) : m("", !0)
    ])) : m("", !0)
  ], 2);
}
const Xe = /* @__PURE__ */ F($e, [["render", Je]]), Ye = {
  name: "SaveToWorkspaceRangeSelector",
  components: {
    FamilySelector: Xe,
    PtIcon: w
  },
  inject: ["service"],
  computed: {
    disabledTooltipOption() {
      const o = this.service.getDisabledAllTypeTooltip();
      return o ? {
        "aria-label": o,
        "data-balloon-pos": "up",
        "data-balloon-white": !0
      } : {};
    },
    allCounts() {
      return this.service.rangeSelector.allCounts;
    },
    groupCounts() {
      return this.service.rangeSelector.groupCounts;
    },
    familyMode() {
      return this.service.familyMode;
    },
    groupMode() {
      return this.service.groupMode;
    },
    selectedGroupCounts() {
      return this.service.searchGroupMode.selectedGroupCounts;
    },
    allGroupCounts() {
      return this.service.allGroupCounts;
    },
    showRangeTip() {
      return this.service.showRangeTip && !this.familyMode;
    },
    familyRangeCount() {
      return this.service.familyRangeCount;
    },
    familyRangeCountLoading() {
      return this.service.familyRangeCountLoading;
    },
    allGroupCountLoading() {
      return this.service.allGroupCountLoading;
    },
    enableFamily() {
      return this.familyMode ? this.service.enableFamily && !this.groupMode : this.service.enableFamily;
    },
    selectAllLabel() {
      const { formatNumber: o } = this.service;
      return this.familyMode && this.groupMode ? this.$t(
        "BaseSaveToWorkspace.RangeSelector.selectAllFamilyLabel",
        { allCounts: o(this.groupCounts) }
      ) : `${this.$t("BaseSaveToWorkspace.RangeSelector.selectAllLabel")} (${o(this.allCounts)})`;
    },
    selectLabel() {
      const { formatNumber: o } = this.service;
      return this.familyMode && this.groupMode ? this.$t(
        "BaseSaveToWorkspace.RangeSelector.selectFamilyLabel",
        { allCounts: o(this.allCounts), count: o(this.selectedGroupCounts) }
      ) : this.$t(
        `BaseSaveToWorkspace.${this.service.type}.RangeSelector.simpleSelectLabel`,
        this.allCounts,
        { count: o(this.allCounts) }
      );
    }
  },
  watch: {
    "service.rangeSelector.selectedType": function(e) {
      const { enableAutoUpdate: t, rangeSelector: s } = this.service;
      e === "RANGE" && s && s.family && (s.family.enable = !1), t && this.service.identifyAutoUpdateStatus && this.service.identifyAutoUpdateStatus();
    }
  },
  methods: {
    changeRangeType(o, e) {
      return e ? !1 : (this.service.rangeSelector.selectedType = o, !0);
    },
    onRangeInputBlur(o, e) {
      if (!o || !o.target)
        return;
      const { value: t } = o.target;
      if (!t) {
        this.service.rangeSelector[e] = "", o.target.value = this.service.rangeSelector[e];
        return;
      }
      const s = parseInt(t, 10);
      if (!c.isNaN(s)) {
        const { min: a } = this.service.rangeSelector;
        this.service.rangeSelector[e] = Math.max(a, s);
      }
      o.target.value = this.service.rangeSelector[e], this.service.getFamilyRangeCount();
    }
  }
}, Ze = { class: "s2w-range-selector-container" }, et = ["innerHTML"], tt = { class: "s2w-range-selector" }, rt = { class: "selector-label" }, st = { class: "range-function-pane" }, ot = {
  key: 0,
  class: "use-select"
}, at = /* @__PURE__ */ d("div", { class: "s2w-range-radio__dot" }, null, -1), lt = { class: "s2w-range-radio__content" }, it = ["innerHTML"], nt = ["innerHTML"], ct = { class: "range-container" }, dt = /* @__PURE__ */ d("div", { class: "s2w-range-radio__dot" }, null, -1), ut = { class: "s2w-range-radio__content" }, pt = { class: "range-label" }, ft = ["value", "disabled"], ht = { class: "range-label" }, mt = ["value", "disabled"], gt = {
  key: 0,
  class: "range-count"
}, St = { class: "range-error" }, yt = ["aria-label"], vt = {
  key: 1,
  class: "use-simple"
}, kt = ["innerHTML"];
function _t(o, e, t, s, a, r) {
  const i = y("PtIcon"), l = y("FamilySelector");
  return n(), p("div", Ze, [
    r.service.rangeSelector.warning ? (n(), p("div", {
      key: 0,
      class: "message-tip",
      innerHTML: r.service.rangeSelector.warning
    }, null, 8, et)) : m("", !0),
    d("div", tt, [
      d("div", rt, h(o.$t("BaseSaveToWorkspace.RangeSelector.title")), 1),
      d("div", st, [
        r.service.enableRange ? (n(), p("div", ot, [
          d("div", x({
            class: ["s2w-range-radio", {
              disabled: r.service.disabledAllType,
              active: r.service.rangeSelector.selectedType === "ALL"
            }]
          }, r.disabledTooltipOption, {
            onClick: e[0] || (e[0] = (f) => r.changeRangeType("ALL", r.service.disabledAllType))
          }), [
            at,
            d("div", lt, [
              d("span", { innerHTML: r.selectAllLabel }, null, 8, it),
              r.allGroupCountLoading ? (n(), p(v, { key: 0 }, [
                r.allGroupCountLoading ? (n(), g(i, {
                  key: 0,
                  icon: "SolidLoadingBars",
                  style: { "font-size": "24px", "margin-left": "4px" }
                })) : m("", !0)
              ], 64)) : (n(), p(v, { key: 1 }, [
                r.familyMode && r.groupMode && r.allGroupCounts ? (n(), p("span", {
                  key: 0,
                  class: _(r.service.disabledAllType ? "s2w-range-radio__content__disabled" : "s2w-range-radio__content__counts"),
                  innerHTML: o.$t(
                    "BaseSaveToWorkspace.RangeSelector.selectAllFamilyPatentCountLabel",
                    { count: r.service.formatNumber(r.allGroupCounts) }
                  )
                }, null, 10, nt)) : m("", !0)
              ], 64))
            ])
          ], 16),
          d("div", ct, [
            d("div", {
              class: _(["s2w-range-radio no-margin", {
                disabled: r.service.disabledRangeType,
                active: r.service.rangeSelector.selectedType === "RANGE"
              }]),
              onClick: e[3] || (e[3] = (f) => r.changeRangeType("RANGE", r.service.disabledAllType))
            }, [
              dt,
              d("div", ut, [
                d("div", {
                  class: _(["range-selector", { "is-error": r.service.rangeSelector.error }])
                }, [
                  d("span", pt, h(o.$t("BaseSaveToWorkspace.RangeSelector.from")), 1),
                  d("input", {
                    class: "range-input",
                    value: r.service.rangeSelector.from,
                    disabled: r.service.disabledRangeType,
                    onBlur: e[1] || (e[1] = (f) => r.onRangeInputBlur(f, "from"))
                  }, null, 40, ft),
                  d("span", ht, h(o.$t("BaseSaveToWorkspace.RangeSelector.to")), 1),
                  d("input", {
                    class: "range-input",
                    value: r.service.rangeSelector.to,
                    disabled: r.service.disabledRangeType,
                    onBlur: e[2] || (e[2] = (f) => r.onRangeInputBlur(f, "to"))
                  }, null, 40, mt)
                ], 2),
                r.familyMode && r.groupMode ? (n(), p("div", gt, [
                  r.familyRangeCountLoading ? (n(), p(v, { key: 0 }, [
                    r.familyRangeCountLoading ? (n(), g(i, {
                      key: 0,
                      icon: "SolidLoadingBars",
                      style: { "font-size": "24px" }
                    })) : m("", !0)
                  ], 64)) : (n(), p(v, { key: 1 }, [
                    P(h(o.$t(
                      "BaseSaveToWorkspace.RangeSelector.familyLabel",
                      { count: r.service.formatNumber(r.familyRangeCount) }
                    )), 1)
                  ], 64))
                ])) : m("", !0)
              ])
            ], 2),
            d("div", St, h(r.service.rangeSelector.error), 1)
          ]),
          r.showRangeTip ? (n(), p("div", {
            key: 0,
            class: "range-info",
            "aria-label": o.$t("BaseSaveToWorkspace.RangeSelector.tip"),
            "data-balloon-pos": "up",
            "data-balloon-white": ""
          }, [
            S(i, {
              icon: "SolidInfo",
              style: { "font-size": "24px" }
            })
          ], 8, yt)) : m("", !0)
        ])) : (n(), p("div", vt, [
          K(o.$slots, "simple", { allCounts: r.allCounts }, () => [
            d("span", { innerHTML: r.selectLabel }, null, 8, kt)
          ])
        ])),
        r.enableFamily ? (n(), g(l, { key: 2 })) : m("", !0)
      ])
    ])
  ]);
}
const O = /* @__PURE__ */ F(Ye, [["render", _t]]), bt = {
  name: "SavePaperToWorkspaceDialog",
  components: {
    BzDialog: D,
    FolderSelector: $,
    RangeSelector: O,
    PtIcon: w
  },
  provide() {
    return {
      service: this.service
    };
  },
  props: {
    service: {
      type: Object,
      required: !0
    }
  }
}, Tt = { class: "dialog-footer flex gap-2" }, wt = ["data-dialog-type", "disabled"];
function Ft(o, e, t, s, a, r) {
  const i = y("RangeSelector"), l = y("FolderSelector"), f = y("PtIcon"), u = y("BzDialog");
  return n(), g(u, x({
    visible: "",
    "custom-class": `pz-save-to-workspace-dialog pz-save-to-workspace-dialog__${t.service.type}`,
    "before-close": () => t.service.onClose(),
    "close-on-click-modal": !1,
    "close-on-press-escape": !1,
    title: o.$t("BaseSaveToWorkspace.Main.title")
  }, o.$attrs), {
    footer: L(() => [
      d("div", Tt, [
        d("button", {
          class: "th-btn th-btn-secondary",
          onClick: e[0] || (e[0] = (k) => t.service.onClose())
        }, h(o.$t("BaseSaveToWorkspace.Main.cancel")), 1),
        d("button", {
          class: "th-btn",
          "data-dialog-type": t.service.type,
          disabled: t.service.isSubmitButtonDisabled(),
          onClick: e[1] || (e[1] = (k) => t.service.onSubmit())
        }, [
          t.service.isSubmitting ? (n(), g(f, {
            key: 0,
            icon: "SolidLoadingBars",
            class: "s2w-submit-loading-icon"
          })) : (n(), p(v, { key: 1 }, [
            P(h(o.$t("BaseSaveToWorkspace.Main.submit")), 1)
          ], 64))
        ], 8, wt)
      ])
    ]),
    default: L(() => [
      S(i),
      S(l)
    ]),
    _: 1
  }, 16, ["custom-class", "before-close", "title"]);
}
const nr = /* @__PURE__ */ F(bt, [["render", Ft]]), Ct = {
  name: "AutoUpdateSelector",
  components: {
    PtIcon: w
  },
  inject: ["service"],
  data() {
    return {
      showQueryPopper: !1
    };
  },
  computed: {
    autoUpdate() {
      return this.service.autoUpdate;
    },
    enable() {
      return this.service.autoUpdate.enable;
    },
    disabled() {
      const {
        rangeSelector: o,
        folderSelector: e,
        disabledAllType: t,
        enableRange: s,
        enableFamily: a
      } = this.service, { selectedFolder: r } = e, { selectedType: i, family: l } = o;
      return !!(r && r.folder_auto_update || i === "RANGE" || a && l.enable || s && t);
    },
    familyMode() {
      return this.service.familyMode;
    },
    AutoUpdateLabel() {
      return this.familyMode ? this.$t("BaseSaveToWorkspace.AutoUpdate.familylabel") : this.$t("BaseSaveToWorkspace.AutoUpdate.label");
    },
    AutoUpdateLabelTip() {
      return this.familyMode ? this.$t("BaseSaveToWorkspace.AutoUpdate.familyTip") : this.$t("BaseSaveToWorkspace.AutoUpdate.tip");
    }
  },
  created() {
    this.closeQueryPopper = () => {
      this.showQueryPopper = !1;
    }, document.addEventListener("mousedown", this.closeQueryPopper);
  },
  beforeUnmount() {
    document.removeEventListener("mousedown", this.closeQueryPopper);
  },
  methods: {
    toggleAutoUpdate() {
      return this.disabled ? !1 : (this.service.toggleAutoUpdate(), !0);
    }
  }
}, Wt = { class: "s2w-auto-update-selector-container" }, Lt = { class: "s2w-auto-update-label" }, Et = { class: "s2w-auto-update-desc" }, Pt = ["aria-label"], It = { class: "s2w-auto-update-query-container" }, Rt = { class: "s2w-auto-update-query-content" }, At = {
  key: 0,
  class: "s2w-auto-update-query-content s2w-efq"
};
function xt(o, e, t, s, a, r) {
  const i = y("PtIcon");
  return n(), p("div", Wt, [
    d("div", Lt, h(o.$t("BaseSaveToWorkspace.AutoUpdate.otherSettingLabel")), 1),
    d("div", {
      class: _(["s2w-auto-update", {
        disabled: r.disabled
      }])
    }, [
      d("div", {
        class: _(["s2w-auto-update-switch", { enable: r.enable }]),
        onClick: e[0] || (e[0] = (l) => r.toggleAutoUpdate())
      }, null, 2),
      d("div", Et, [
        d("span", null, h(r.AutoUpdateLabel), 1)
      ]),
      d("div", {
        class: "s2w-auto-update-info",
        "aria-label": r.AutoUpdateLabelTip,
        "data-balloon-pos": "up",
        "data-balloon-white": ""
      }, [
        S(i, {
          icon: "SolidInfo",
          style: { "font-size": "24px" }
        })
      ], 8, Pt),
      d("div", It, [
        d("div", {
          class: "s2w-auto-update-query-link",
          onClick: e[1] || (e[1] = (l) => a.showQueryPopper = !a.showQueryPopper)
        }, h(o.$t("BaseSaveToWorkspace.AutoUpdate.viewQuery")), 1),
        a.showQueryPopper ? (n(), p("div", {
          key: 0,
          class: "s2w-auto-update-query-popper",
          onMousedown: e[2] || (e[2] = T(() => {
          }, ["stop"]))
        }, [
          d("div", Rt, h(r.autoUpdate.q), 1),
          r.autoUpdate.efq ? (n(), p("div", At, h(o.$t("BaseSaveToWorkspace.AutoUpdate.refine")) + ": " + h(r.autoUpdate.efq), 1)) : m("", !0)
        ], 32)) : m("", !0)
      ])
    ], 2)
  ]);
}
const Nt = /* @__PURE__ */ F(Ct, [["render", xt]]), Mt = { class: "dialog-footer flex gap-2" }, Ut = ["data-dialog-type", "disabled"], cr = /* @__PURE__ */ q({
  __name: "Patent",
  props: {
    service: {
      type: Object,
      required: !0
    }
  },
  setup(o) {
    const e = o, { t } = H();
    return V("service", e.service), (s, a) => (n(), g(W(D), x({
      visible: "",
      "custom-class": `pz-save-to-workspace-dialog pz-save-to-workspace-dialog__${o.service.type}`,
      "before-close": () => o.service.onClose(),
      "close-on-click-modal": !1,
      "close-on-press-escape": !1,
      title: W(t)("BaseSaveToWorkspace.Main.title")
    }, s.$attrs), {
      footer: L(() => [
        d("div", Mt, [
          d("button", {
            class: "th-btn th-btn-secondary",
            size: "small",
            onClick: a[0] || (a[0] = (r) => o.service.onClose())
          }, h(W(t)("BaseSaveToWorkspace.Main.cancel")), 1),
          d("button", {
            class: "th-btn",
            "data-dialog-type": o.service.type,
            disabled: o.service.isSubmitButtonDisabled(),
            onClick: a[1] || (a[1] = (r) => o.service.onSubmit())
          }, [
            o.service.isSubmitting ? (n(), g(W(w), {
              key: 0,
              icon: "SolidLoadingBars",
              class: "s2w-submit-loading-icon"
            })) : (n(), p(v, { key: 1 }, [
              P(h(W(t)("BaseSaveToWorkspace.Main.submit")), 1)
            ], 64))
          ], 8, Ut)
        ])
      ]),
      default: L(() => [
        S(O),
        S($),
        o.service.enableAutoUpdate ? (n(), g(Nt, { key: 0 })) : m("", !0)
      ]),
      _: 1
    }, 16, ["custom-class", "before-close", "title"]));
  }
});
export {
  G as BasicService,
  $ as FolderSelector,
  lr as PaperService,
  ir as PatentService,
  nr as SavePaperToWorkspace,
  cr as SavePatentToWorkspace
};
